import React, { useEffect, useState } from 'react';
import { api, btnPrimary, btnSecondary, InlineError, input, labelCls, Modal, useToast } from '../ui/Kit';

// Out of office (Settings and the Approvals page): from / to + a delegate. While it's on, your approvals and jobs to
// assign also go to the delegate, who acts "on behalf of" you.
export function OutOfOfficeForm({ onSaved }) {
  const toast = useToast();
  const [data, setData] = useState(null);
  const [f, setF] = useState({ starts_on: '', ends_on: '', delegate_user_id: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = async () => {
    try {
      const d = await api('/api/me/out-of-office');
      setData(d);
      if (d.current) setF({ starts_on: d.current.starts_on, ends_on: d.current.ends_on, delegate_user_id: String(d.current.delegate_user_id) });
    } catch (e) { setError(e.message); setData({ current: null, delegates: [], delegated_to_me: [] }); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    setError(''); setBusy(true);
    try {
      const d = await api('/api/me/out-of-office', { method: 'PUT', body: { ...f, delegate_user_id: Number(f.delegate_user_id) } });
      setData(d); toast && toast.show('Out of office saved'); onSaved && onSaved(d);
    } catch (e) { setError(e.message); }
    setBusy(false);
  };
  const clear = async () => {
    setError(''); setBusy(true);
    try { setData(await api('/api/me/out-of-office', { method: 'DELETE' })); setF({ starts_on: '', ends_on: '', delegate_user_id: '' }); toast && toast.show('Out of office turned off'); onSaved && onSaved(null); }
    catch (e) { setError(e.message); }
    setBusy(false);
  };
  if (!data) return <p className="text-sm text-[#64748B]">Loading…</p>;
  const cur = data.current;
  return (
    <div className="space-y-3" data-testid="ooo-form">
      {cur && <p role="status" className={`text-sm rounded-lg px-3 py-2 ${cur.active ? 'bg-[#FEF3C7] text-[#92400E]' : 'bg-[#F1F5F9] text-[#334155]'}`}>
        {cur.active ? 'You are out of office now' : 'Scheduled'} — {cur.starts_on} to {cur.ends_on}, delegate <b>{cur.delegate_name}</b></p>}
      <div className="grid grid-cols-2 gap-3">
        <label className="block"><span className={labelCls}>From</span><input type="date" className={input} value={f.starts_on} onChange={(e) => setF({ ...f, starts_on: e.target.value })} /></label>
        <label className="block"><span className={labelCls}>To</span><input type="date" className={input} value={f.ends_on} onChange={(e) => setF({ ...f, ends_on: e.target.value })} /></label>
      </div>
      <label className="block"><span className={labelCls}>Delegate</span>
        <select className={input} value={f.delegate_user_id} onChange={(e) => setF({ ...f, delegate_user_id: e.target.value })}>
          <option value="">Choose a colleague…</option>
          {data.delegates.map((p) => <option key={p.id} value={p.id}>{p.full_name}</option>)}
        </select></label>
      <p className="text-xs text-[#64748B]">Your approvals and jobs to assign also go to your delegate, who acts on your behalf (shown on the job's timeline). At most 90 days.</p>
      <InlineError>{error}</InlineError>
      <div className="flex gap-2">
        <button className={btnPrimary} disabled={busy || !f.starts_on || !f.ends_on || !f.delegate_user_id} onClick={save}>Save</button>
        {cur && <button className={btnSecondary} disabled={busy} onClick={clear}>Turn off</button>}
      </div>
      {data.delegated_to_me.length > 0 && <p className="text-xs text-[#334155]">You're covering for {data.delegated_to_me.map((x) => x.full_name).join(', ')}.</p>}
    </div>
  );
}

export function OutOfOfficeDialog({ open, onClose }) {
  return (
    <Modal open={open} title="Out of office" onClose={onClose} width="max-w-md">
      <OutOfOfficeForm onSaved={() => onClose()} />
    </Modal>
  );
}
